import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { motion } from "framer-motion";
import { Construction } from "lucide-react";

export default function ComingSoon({ titleKey, phase = 2 }) {
  const { t } = useTranslation();
  return (
    <motion.div
      data-testid="coming-soon-page"
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4 }}
      className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6"
    >
      <div className="h-24 w-24 rounded-3xl bg-gradient-primary flex items-center justify-center mb-6 shadow-2xl shadow-sky/20">
        <Construction className="h-10 w-10 text-white" />
      </div>
      <div className="text-xs uppercase tracking-[0.32em] text-sky">{t(titleKey)}</div>
      <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-wider mt-2 brand-gradient-text">
        {t("common.comingSoon").toUpperCase()}
      </h1>
      <Badge
        variant="secondary"
        className="mt-4 bg-white/10 border-[var(--surface-border)] text-xs uppercase tracking-widest"
        data-testid="phase-badge"
      >
        {t("common.comingInPhase", { phase })}
      </Badge>
    </motion.div>
  );
}
